import { useEffect, useState } from "react";

function usePagination({ initialState = {}, data = [] }) {
  const { page, perPage } = initialState;

  const [pageNo, setPageNo] = useState(page || 1);
  const [limit, setLimit] = useState(perPage || 10);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPageData, setCurrentPageData] = useState(data);

  useEffect(() => {
    const noOfPages = Math.ceil(data?.length / limit);
    if (noOfPages < page) {
      setPageNo(noOfPages);
    }
    setTotalPages(noOfPages);
  }, [data, limit, page]);

  useEffect(() => {
    const currentPageIndex = (pageNo - 1) * limit;
    const nextPageIndex = pageNo * limit;
    const pageData = data.slice(currentPageIndex, nextPageIndex);
    setCurrentPageData(pageData);
  }, [data, limit, pageNo]);

  const isPerviousPage = pageNo > 1;
  const isNextPage = pageNo < totalPages;

  const getStart = () => {
    if (pageNo === 1) return 1;
    else if (pageNo === totalPages) return pageNo <= 2 ? 1 : pageNo - 2;
    else return pageNo - 1;
  };

  const getEnd = () => {
    if (pageNo === 1) return 4;
    else if (pageNo === totalPages) return pageNo + 1;
    else return pageNo + 2;
  };

  const pages = [...Array(totalPages + 1).keys()].slice(getStart(), getEnd());

  return {
    pageNo,
    setPageNo,
    limit,
    setLimit,
    totalPages,
    currentPageData,
    isPerviousPage,
    isNextPage,
    pages,
  };
}

export default usePagination;
